<p-treeTable #menuTreeTable [value]="treeData" [columns]="cols" selectionMode="checkbox" [(selection)]="selectedNodes3"
  dataKey="label" [resizableColumns]="true">
  <ng-template pTemplate="caption">
    <div style="text-align: right">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input type="text" pInputText size="50" placeholder="Menu Filter"
          (input)="menuTreeTable.filterGlobal($event.target.value, 'contains')" style="width:auto" />
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngFor="let col of columns" ttResizableColumn>
        {{ col.header }}
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
    <tr [class.bold-label]="(rowNode.node.data.type === 'dropdown' || rowNode.node.data.type === 'subheading')"
        [class.disabled-row]="rowNode.node.data.disabled">
      <td *ngFor="let col of columns; let i = index">
        <p-treeTableToggler id="{{ i }}" [rowNode]="rowNode" *ngIf="i == 0"
          (click)="onTogglerClick($event, rowNode)"></p-treeTableToggler>
        <input *ngIf="col.field === 'label'" [(ngModel)]="rowNode.node.data.isSelected" type="checkBox"
          (change)="nodeSelect($event, rowNode)" class="custom-checkbox" 
          [disabled]="rowNode.node.data.disabled" />
        <ng-container *ngIf="col.field !== 'label'">
          <p-inputSwitch *ngIf="rowNode.node.data.type === 'link'" (onChange)="onChange(rowNode, 'singleSelect')"
            [(ngModel)]="rowData[col.field]" [disabled]="rowNode.node.data.disabled"></p-inputSwitch>
        </ng-container>
        <span *ngIf="col.field === 'label'" [class.disabled-text]="rowNode.node.data.disabled">{{ rowData[col.field] }}</span>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="cols.length">No data found.</td>
    </tr>
  </ng-template>
</p-treeTable>